import { types } from '@/store/types';

const STORAGE_KEY = 'webshop';
const COOKIES_STORAGE_KEY = 'webshopAcceptCookies';
const BACKEND_VERSION_HEADER = 'x-backend-version';

const EXCLUDED_STATE_PATHS = [
  types.state.PRICES,
  types.state.DELIVERY_DATA,
  types.state.STOCK,
  types.state.IS_CART_OPEN,
  types.state.SERUM_INCI_LISTS,
  types.state.SELECTED_EYE_SERUM_GENERIC_FORMULA_ID,
  types.state.IS_LOADING
];

const PATHS_TO_PERSIST = Object.values(types.state).filter(
  path => !EXCLUDED_STATE_PATHS.includes(path)
);

export { STORAGE_KEY, PATHS_TO_PERSIST, COOKIES_STORAGE_KEY, BACKEND_VERSION_HEADER };
